import React from 'react';
import { useIconThemed } from '../use-icon-themed';
export default function IconList() {
  var _useIconThemed = useIconThemed(),
    iconThemed = _useIconThemed.iconThemed;
  var dotColour = iconThemed({
    light: '#6C798F',
    dark: '#5A6977'
  });
  var lineColour = iconThemed({
    light: '#C1C7D0',
    dark: '#454F59'
  });
  return /*#__PURE__*/React.createElement("svg", {
    focusable: "false",
    "aria-hidden": true,
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: iconThemed({
      light: '#FFF',
      dark: '#161A1D'
    }),
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 10)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: dotColour,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: lineColour,
    x: 7,
    y: 9,
    width: 17,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: lineColour,
    x: 7,
    y: 1,
    width: 17,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: lineColour,
    x: 7,
    y: 17,
    width: 17,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: dotColour,
    y: 8,
    width: 4,
    height: 4,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    fill: dotColour,
    y: 16,
    width: 4,
    height: 4,
    rx: 2
  }))));
}